<template>
  <div>
    <div class="row">
      <div class="col-10">
        <OrderDIFOTSummaryWidget :filter="filter" :gridHeight="280" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="280">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/difot/orders">DIFOT Orders Report</AnalyticsReportLink>            
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <OrderDIFOTSummaryDetailsWidget :filter="filter" :gridHeight="280" />
      </div>
    </div>

    <!-- Show for all task types. Pickups now have op reporting auto-generated -->
    <div class="row" v-for="taskType in taskTypeList" :key="`report-link-${taskType.id}`">
      <div class="col-12">
        <OrderDIFOTBreakdownWidget :filter="filter" :gridHeight="260" :taskType="taskType" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="630" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-difot-monthly-operational">
              <i class="tabbedbox-tab-icon fas fa-truck"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Operational</div>
                <div class="tabbedbox-tab-subtitle">Monthly Operational DIFOT</div>
              </div>
            </Tab>
            <Tab tabid="tab-difot-monthly-collection">
              <i class="tabbedbox-tab-icon fas fa-dolly-flatbed"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Collection</div>
                <div class="tabbedbox-tab-subtitle">Monthly Collection Delay</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-difot-monthly-operational" class="tabpage-padding-2">
              <OrderDIFOTMonthlyOperationalWidget
                :gridHeight="500"
                :embedded="true"
                :filter="filter"
              />
            </TabPage>
            <TabPage tabid="tab-difot-monthly-collection" class="tabpage-padding-2">
              <OrderDIFOTMonthlyCollectionWidget
                :gridHeight="500"
                :embedded="true"
                :filter="filter"
              />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="680" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-difot-resultstype-missed">
              <i class="tabbedbox-tab-icon fas fa-clipboard"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Results</div>
                <div class="tabbedbox-tab-subtitle">Internal Caused Miss Breakdown</div>
              </div>
            </Tab>
            <Tab tabid="tab-difot-resultstype-hits">
              <i class="tabbedbox-tab-icon fas fa-clipboard-check"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Results</div>
                <div class="tabbedbox-tab-subtitle">Hit Breakdown</div>
              </div>
            </Tab>
            <Tab tabid="tab-difot-resultstype-exclude">
              <i class="tabbedbox-tab-icon fas fa-window-close"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Results</div>
                <div class="tabbedbox-tab-subtitle">Exclude Breakdown</div>
              </div>
            </Tab>
            <Tab tabid="tab-difot-resultstype-alllate">
              <i class="tabbedbox-tab-icon fas fa-stopwatch"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Results</div>
                <div class="tabbedbox-tab-subtitle">Full Lateness Breakdown</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-difot-resultstype-missed" class="tabpage-padding-2">
              <OrderDIFOTResultsChartWidget
                :type="DIFOTResultChartTypes.internalCauseMissList"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :showDateFilter="true"
                :filter="filter"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedDIFOTFilter.startDate"
                :endDate="appliedDIFOTFilter.endDate"
                @updateEditingStartDate="editingDIFOTFilter.startDate = $event"
                @updateEditingEndDate="editingDIFOTFilter.endDate = $event"
                @dateApplied="applyDIFOTFilter"
                @dateReset="resetDIFOTFilter"
              />
            </TabPage>
            <TabPage tabid="tab-difot-resultstype-hits" class="tabpage-padding-2">
              <OrderDIFOTResultsChartWidget
                :type="DIFOTResultChartTypes.successHitList"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :showDateFilter="true"
                :filter="filter"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedDIFOTFilter.startDate"
                :endDate="appliedDIFOTFilter.endDate"
                @updateEditingStartDate="editingDIFOTFilter.startDate = $event"
                @updateEditingEndDate="editingDIFOTFilter.endDate = $event"
                @dateApplied="applyDIFOTFilter"
                @dateReset="resetDIFOTFilter"
              />
            </TabPage>
            <TabPage tabid="tab-difot-resultstype-exclude" class="tabpage-padding-2">
              <OrderDIFOTResultsChartWidget
                :type="DIFOTResultChartTypes.excludeList"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :showDateFilter="true"
                :filter="filter"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedDIFOTFilter.startDate"
                :endDate="appliedDIFOTFilter.endDate"
                @updateEditingStartDate="editingDIFOTFilter.startDate = $event"
                @updateEditingEndDate="editingDIFOTFilter.endDate = $event"
                @dateApplied="applyDIFOTFilter"
                @dateReset="resetDIFOTFilter"
              />
            </TabPage>
            <TabPage tabid="tab-difot-resultstype-alllate" class="tabpage-padding-2">
              <OrderDIFOTResultsChartWidget
                :type="DIFOTResultChartTypes.fullLatenessList"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :showDateFilter="true"
                :filter="filter"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedDIFOTFilter.startDate"
                :endDate="appliedDIFOTFilter.endDate"
                @updateEditingStartDate="editingDIFOTFilter.startDate = $event"
                @updateEditingEndDate="editingDIFOTFilter.endDate = $event"
                @dateApplied="applyDIFOTFilter"
                @dateReset="resetDIFOTFilter"
              />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <OrderDIFOTContactListWidget :filter="filter" :gridHeight="600" />
      </div>
      <div class="col-4">
        <OrderDIFOTPendingCollectionWidget :filter="filter" :gridHeight="600" />
      </div>
      <div class="col-4">
        <OrderDIFOTLateOrderListWidget :filter="filter" :gridHeight="600" />
      </div>
    </div>

    <div class="row">
      <div class="col-4">
        <OrderDIFOTSlowCollectorsWidget :filter="filter" :gridHeight="420" />
      </div>
      <div class="col-4">
        <OrderDIFOTOutboundTaskPerformanceWidget :filter="filter" :gridHeight="420" />
      </div>
      <div class="col-4">
        <OrderDIFOTCollectionTaskPerformanceWidget :filter="filter" :gridHeight="420" />
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import OrderDIFOTSummaryWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTSummaryWidget'
import OrderDIFOTSummaryDetailsWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTSummaryDetailsWidget'
import OrderDIFOTBreakdownWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTBreakdownWidget'
import OrderDIFOTContactListWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTContactListWidget'
import OrderDIFOTPendingCollectionWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTPendingCollectionWidget'
import OrderDIFOTLateOrderListWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTLateOrderListWidget'
import OrderDIFOTSlowCollectorsWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTSlowCollectorsWidget'
import OrderDIFOTOutboundTaskPerformanceWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTOutboundTaskPerformanceWidget'
import OrderDIFOTCollectionTaskPerformanceWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTCollectionTaskPerformanceWidget'
import OrderDIFOTMonthlyOperationalWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTMonthlyOperationalWidget'
import OrderDIFOTMonthlyCollectionWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTMonthlyCollectionWidget'
import OrderDIFOTResultsChartWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTResultsChartWidget'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsDIFOTDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,

    ReportFilterPopover,
    ReportDateRangeSelect,

    OrderDIFOTSummaryWidget,
    OrderDIFOTSummaryDetailsWidget,
    OrderDIFOTBreakdownWidget,
    OrderDIFOTContactListWidget,
    OrderDIFOTPendingCollectionWidget,
    OrderDIFOTLateOrderListWidget,
    OrderDIFOTSlowCollectorsWidget,
    OrderDIFOTOutboundTaskPerformanceWidget,
    OrderDIFOTCollectionTaskPerformanceWidget,
    OrderDIFOTMonthlyOperationalWidget,
    OrderDIFOTMonthlyCollectionWidget,
    OrderDIFOTResultsChartWidget
  },
  props: {
    filter: Object
  },
  data() {
    return {
      defaultTaskFilter: {    
        startDate: moment().local().subtract(6, 'month').startOf('day').toDate().toISOString(),
        endDate: moment().local().endOf('day').toDate().toISOString()
      },
      editingTaskFilter: {},
      appliedTaskFilter: {},

      defaultDIFOTFilter: {    
        startDate: moment().local().subtract(60, 'days').startOf('day').toDate().toISOString(),
        endDate: moment().local().endOf('day').toDate().toISOString()
      },
      editingDIFOTFilter: {},
      appliedDIFOTFilter: {},

      taskTypeList: []
    }
  },
  computed: {
    reportingTaskTypeList() {
      return this.taskTypeList.filter(type => type.isOperationalReportingEnabled)
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.DIFOTResultChartTypes = OrderDIFOTResultsChartWidget.DIFOTResultChartTypes
  },
  mounted() {
    this.editingTaskFilter = _.clone(this.defaultTaskFilter)
    this.appliedTaskFilter = _.clone(this.defaultTaskFilter)

    this.editingDIFOTFilter = _.clone(this.defaultDIFOTFilter)
    this.appliedDIFOTFilter = _.clone(this.defaultDIFOTFilter)

    this.requestTaskData()
  },
  beforeDestroy() {
    
  },
  methods: {
    applyTaskFilter() {
      this.appliedTaskFilter = _.clone(this.editingTaskFilter)
    },
    resetTaskFilter() {
      this.editingTaskFilter = _.clone(this.defaultTaskFilter)
      this.appliedTaskFilter = _.clone(this.defaultTaskFilter)
    },

    requestTaskData() {
      this.$apiService.tasksService.getTaskTypeList({ filter: { isActive: 1 } })
      .then(response => {
        this.taskTypeList = response.data
      })
      .catch(err => {
        console.error(err)
      })
    },

    applyDIFOTFilter() {
      this.appliedDIFOTFilter = _.clone(this.editingDIFOTFilter)
    },
    resetDIFOTFilter() {
      this.editingDIFOTFilter = _.clone(this.defaultDIFOTFilter)
      this.appliedDIFOTFilter = _.clone(this.defaultDIFOTFilter)
    }
  }
  
}
</script>